interface NotesEditorProps {
  notes: string;
  onChange: (notes: string) => void;
}

const NotesEditor = ({ notes, onChange }: NotesEditorProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-lg flex items-center justify-center">
            <i className="ri-edit-fill text-white text-sm"></i>
          </div>
          <h3 className="text-lg font-semibold text-slate-900">Manual Notes</h3>
        </div>
        <span className="text-xs text-slate-500">{notes.length} characters</span>
      </div>

      <div className="relative">
        <textarea
          value={notes}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Add your own notes, observations, or annotations here...&#10;&#10;• Use bullet points for clarity&#10;• Highlight important details&#10;• Add context that wasn't captured in the recording"
          className="w-full h-96 px-4 py-3 bg-slate-50 border border-slate-200 rounded-lg text-slate-700 text-sm leading-relaxed resize-none focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
        />
      </div>

      <div className="flex items-center gap-3">
        <button className="flex-1 px-4 py-2 bg-white border border-slate-200 text-slate-700 rounded-lg text-sm font-medium hover:bg-slate-50 transition-colors whitespace-nowrap flex items-center justify-center gap-2">
          <i className="ri-file-copy-line"></i>
          Copy Notes
        </button>
        <button className="flex-1 px-4 py-2 bg-white border border-slate-200 text-slate-700 rounded-lg text-sm font-medium hover:bg-slate-50 transition-colors whitespace-nowrap flex items-center justify-center gap-2">
          <i className="ri-delete-bin-line"></i>
          Clear Notes
        </button>
        <button className="flex-1 px-4 py-2 bg-gradient-to-r from-teal-500 to-blue-500 text-white rounded-lg text-sm font-medium hover:from-teal-600 hover:to-blue-600 transition-all whitespace-nowrap flex items-center justify-center gap-2">
          <i className="ri-save-line"></i>
          Save Notes
        </button>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <i className="ri-information-fill text-blue-500 text-lg flex-shrink-0"></i>
          <div>
            <h4 className="text-sm font-semibold text-blue-900 mb-1">Pro Tip</h4>
            <p className="text-xs text-blue-700 leading-relaxed">
              Your notes are automatically saved as you type. Use this space to add context, personal observations, or follow-up tasks that complement the AI transcript.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotesEditor;